import React from "react";
import { useTranslation } from "react-i18next";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";

const ServiceSelect = ({ label, name, value, options, onChange }) => (
    <Grid size={{ xs: 12, sm: 6 }}>
        <FormControl fullWidth size="small">
            <InputLabel>{label}</InputLabel>
            <Select label={label} name={name} value={value} onChange={onChange}>
                {options.map((opt) => (
                    <MenuItem key={opt.code} value={opt.code}>{opt.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    </Grid>
);

export const ServiceFields = ({ dto, options, handleInputChange }) => {
    const { t } = useTranslation();

    if (dto.type !== "Servicio") return null;

    return (
        <>
            <ServiceSelect
                label={t("crm.products.category")}
                name="category"
                value={dto.category}
                options={options.categories}
                onChange={handleInputChange}
            />
            <ServiceSelect
                label={t("crm.products.line")}
                name="line"
                value={dto.line}
                options={options.lines}
                onChange={handleInputChange}
            />
            <ServiceSelect
                label={t("crm.products.subLine")}
                name="subline"
                value={dto.subline}
                options={options.sublines}
                onChange={handleInputChange}
            />
            <ServiceSelect
                label="ANS"
                name="ans"
                value={dto.ans}
                options={options.ansList}
                onChange={handleInputChange}
            />
        </>
    );
};